import { OrganizationAccountInfoFields } from './isOrganizationAccountInfoComplete'

interface CompanyAccountInfoFormFields {
  companyAddress?: string
  companyCity?: string
  companyName: string
  companyZipCode?: string
  isSiretPendingAssignment?: boolean
  isVatExempted: boolean
  registrationNo?: string
  vatNo?: string
}

export const mapCompanyFormToAccountInfo = (
  companyForm: CompanyAccountInfoFormFields,
  countryId?: string,
): OrganizationAccountInfoFields => {
  const {
    companyAddress,
    companyCity,
    companyName,
    companyZipCode,
    isSiretPendingAssignment,
    isVatExempted,
    registrationNo,
    vatNo,
  } = companyForm

  return {
    city: companyCity,
    countryId,
    isSiretPendingAssignment,
    isVatExempted,
    name: companyName,
    registrationNo,
    street: companyAddress,
    vatNo,
    zipcode: companyZipCode,
  }
}
